import type { ReactNode } from 'react';
import { cn } from '../cn';

export function EmptyState({ label, hint, action, className }: { label: string; hint?: string; action?: ReactNode; className?: string }) {
  return (
    <div className={cn('flex flex-col items-center gap-2.5 px-4 py-8 text-center', className)}>
      <span className="micro text-fg4">{label}</span>
      {hint && <span className="max-w-[320px] text-pretty text-base font-normal leading-[1.5] text-fg3">{hint}</span>}
      {action}
    </div>
  );
}

/** Loading placeholder: track fill, radius 4, pulse. */
export function Skeleton({ className, w, h = 12 }: { className?: string; w?: number | string; h?: number | string }) {
  return <span aria-hidden className={cn('block animate-pulse rounded-sm bg-track', className)} style={{ width: w ?? '100%', height: h }} />;
}

export function SkeletonRows({ rows = 4, className }: { rows?: number; className?: string }) {
  return (
    <div className={cn('flex flex-col', className)}>
      {Array.from({ length: rows }, (_, i) => (
        <div key={i} className="flex items-center gap-3 border-t border-line px-4 py-3.5">
          <Skeleton w="30%" />
          <Skeleton w="45%" />
          <Skeleton w="10%" />
        </div>
      ))}
    </div>
  );
}
